import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const geofenceState = (state) => state.geofence;
export const groupItemsSelector = createSelector(geofenceState, (geofence) => geofence.groupItems);
export const groupSearchValueSelector = createSelector(geofenceState, (geofence) => geofence.groupSearchValue);
export const groupSelectedItemSelector = createSelector(geofenceState, (geofence) => geofence.groupSelectedItem);
export const sortItemsSelector = createSelector([groupItemsSelector, groupSearchValueSelector], (groupItems, groupSearchValue) => {
    const compareFn = (a, b) => a.name.localeCompare(b.name);
    if (groupSearchValue.length) {
        return groupItems.filter((item) => translitToRus(item.name).indexOf(translitToRus(groupSearchValue)) !== -1).sort(compareFn);
    }
    return groupItems.sort(compareFn);
});
